export default "__VITE_ASSET__Dslq7T0A__"